import { get, logError } from 'utils';

export default function getOrderService(
  params = {},
  onSuccess = () => {},
  onError = () => {},
  onFinally = () => {}
) {
  return get({ apiKey: 'requests.get' }, { params })
    .then(({ data }) => onSuccess(data))
    .catch(err => {
      logError(err);
      onError(err);
    })
    .finally(onFinally);
}
